import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'la-clear-sky',
  template: `
    <svg
        class="climacon climacon_sun"
        enable-background="new 15 15 70 70"
        id="sun"
        version="1.1"
        viewBox="15 15 70 70"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        y="0px">

      <clipPath id="sunFillClip">
            <path
                d="M0,0v100h100V0H0z M50.001,57.999c-4.417,0-8-3.582-8-7.999c0-4.418,3.582-7.999,8-7.999s7.998,3.581,7.998,7.999C57.999,54.417,54.418,57.999,50.001,57.999z"
            />
        </clipPath>
      <g>
            <g class="la-clear-sky-component-wrap-sun">
                <g class="la-clear-sky-component-wrap-sunSpoke">
                    <path
                        class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-east"
                        d="M72.03,51.999h-3.998c-1.105,0-2-0.896-2-1.999s0.895-2,2-2h3.998c1.104,0,2,0.896,2,2S73.136,51.999,72.03,51.999z"
                    />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-northEast"
                      d="M64.175,38.688c-0.781,0.781-2.049,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l2.828-2.828c0.779-0.781,2.047-0.781,2.828,0c0.779,0.781,0.779,2.047,0,2.828L64.175,38.688z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-north"
                      d="M50.034,34.002c-1.105,0-2-0.896-2-2v-3.999c0-1.104,0.895-2,2-2c1.104,0,2,0.896,2,2v3.999C52.034,33.106,51.136,34.002,50.034,34.002z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-northWest"
                      d="M35.893,38.688l-2.827-2.828c-0.781-0.781-0.781-2.047,0-2.828c0.78-0.781,2.047-0.781,2.827,0l2.827,2.828c0.781,0.781,0.781,2.047,0,2.828C37.94,39.469,36.674,39.469,35.893,38.688z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-west"
                      d="M34.034,50c0,1.104-0.896,1.999-2,1.999h-4c-1.104,0-1.998-0.896-1.998-1.999s0.896-2,1.998-2h4C33.14,48,34.034,48.896,34.034,50z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-southWest"
                      d="M35.893,61.312c0.781-0.78,2.048-0.78,2.827,0c0.781,0.78,0.781,2.047,0,2.828l-2.827,2.827c-0.78,0.781-2.047,0.781-2.827,0c-0.781-0.78-0.781-2.047,0-2.827L35.893,61.312z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-south"
                      d="M50.034,65.998c1.104,0,2,0.895,2,1.999v4c0,1.104-0.896,2-2,2c-1.105,0-2-0.896-2-2v-4C48.034,66.893,48.929,65.998,50.034,65.998z"
                  />
                  <path
                      class="la-clear-sky-sun-spoke la-clear-sky-sun-spoke-southEast"
                      d="M64.175,61.312l2.828,2.828c0.779,0.78,0.779,2.047,0,2.827c-0.781,0.781-2.049,0.781-2.828,0l-2.828-2.827c-0.781-0.781-0.781-2.048,0-2.828C62.126,60.531,63.392,60.531,64.175,61.312z"
                  />
                </g>
              <g clip-path="url(#sunFillClip)">
                    <circle
                        cx="50.034"
                        cy="50"
                        r="11.999"
                    />
                </g>
            </g>
        </g>
    </svg><!-- sun -->
  `,
  styles: [`
    svg{shape-rendering:geometricPrecision;fill:#ffb22f}circle,g,path,rect{-webkit-transform-origin:50% 50%;transform-origin:50% 50%;transform-box:fill-box;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-direction:normal;animation-direction:normal;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-duration:12s;animation-duration:12s}.la-clear-sky-component-wrap-sun{-webkit-animation-name:clear-sky-rotate;animation-name:clear-sky-rotate}.la-clear-sky-sun-spoke{-webkit-animation-name:clear-sky-scale;animation-name:clear-sky-scale;-webkit-animation-direction:alternate;animation-direction:alternate;-webkit-animation-duration:3s;animation-duration:3s}.la-clear-sky-sun-spoke:nth-child(2n){-webkit-animation-delay:3s;animation-delay:3s}@-webkit-keyframes clear-sky-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes clear-sky-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes clear-sky-scale{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.5);transform:scale(.5)}}@keyframes clear-sky-scale{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.5);transform:scale(.5)}}
  `]
})
export class LaClearSkyComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
